<template>
    <div class="fullWidth">
        <kgr-loading
            v-if="loading"
            :inline="true"
        />
        <kgr-generic-select
            v-else
            v-model="selection"
            :options="options"
            display="name"
            :disabled="disabled"
            @post-input="updateLanguage()"
        />
    </div>
</template>

<script>
import CountriesRepository from '../../../../js/repository/CountriesRepository';
import GenericSelect from './GenericSelect.vue';
import Loading from '../../Loading.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
        'kgr-loading': Loading,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            options: [],
            selection: null,
            loading: true,
        };
    },
    created() {
        CountriesRepository.findAll()
            .then((countries) => {
                this.loading = false;
                this.options = countries;

                countries.forEach((language) => {
                    if (language.code === this.value) {
                        this.selection = language;
                    }
                });
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        updateLanguage() {
            const code = this.selection ? this.selection.code : null;
            this.$emit('input', code);
            this.$nextTick(() => {
                this.$emit('post-input', code);
            });
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .fullWidth {
    width: 100%;
}
</style>
